import type { StyleRule } from '@archipro-design/aria';
import {
    tabsClassName,
    pxToRem,
    pxArrayToRem,
    labelClassName,
} from '@archipro-design/aria';
import { ShopCheckboxFilter } from '@modules/category/component/category-filter-section/CategoryFilterSection.style';

export const MobileFilterWarp: StyleRule = () => {
    return {
        padding: pxArrayToRem([17, 0, 10]),
        marginBottom: pxToRem(10),
        height: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
};

export const MobileButtonFilters: StyleRule = ({ theme }) => ({
    textTransform: 'uppercase',
    [`& .${labelClassName}`]: {
        ...theme.siteVariables.textStyles.Heading.Roman55,
    },
});

export const MobileSearchDrawer: StyleRule = () => ({
    overflow: 'hidden',
    position: 'relative',
});

export const DesktopFilterWarp: StyleRule = () => ({});

export const DesktopFilterGroup: StyleRule = () => ({
    columnGap: pxToRem(24),
    marginRight: pxToRem(7.5),
});

export const SearchBarWarp: StyleRule = () => ({});

export const SortButtonWarp: StyleRule = () => ({});

export const FilterButtonsWarp: StyleRule = () => ({
    height: pxToRem(39),
    [`& .shopCheckbox`]: ShopCheckboxFilter(),
});

export const SelectedFiltersWarp: StyleRule = () => ({
    marginTop: pxToRem(25),
});

export const RightSectionProjectWarp: StyleRule = () => ({
    flexGrow: 1,
    textAlign: 'right',
    [`& .${tabsClassName}`]: {
        justifyContent: 'end',
        marginLeft: 'auto',
    },
});
